// extracted by mini-css-extract-plugin
module.exports = {"clubsuper3":"globals_clubsuper3__aiK0D"};